import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import Uploader from "@edaz/edazkit/Uploader";
import { Input } from "@frui.ts/bootstrap";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import localizationProvider from "localization/localizationProvider";
import { translateGeneral } from "utils/localizations";
import type BulkExemptionsViewModel from "viewModels/callCenter/actions/bulkExemptionsViewModel";
import { File } from "views/common/file";
import FormLabel from "controls/formLabel";

const BulkExemptionsFormView: ViewComponent<BulkExemptionsViewModel> = observer(({ vm }) => {
  return (
    <>
      <Form.Row>
        <Form.Group as={Col}>
          <FormLabel target={vm.item} property="officialRecordId">
            {vm.translateAttribute("officialRecordId")}
          </FormLabel>
          <Input target={vm} property="officialRecordId" errorMessage={vm.officialRecordIdError} />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col}>
          <FormLabel target={vm.item} property="reason">
            {vm.translateAttribute("reason")}
            {vm.isCancelation && <span className="pl-2">{translateGeneral("optional")}</span>}
          </FormLabel>
          <AdvancedSelect
            className="autoHeight"
            target={vm.item}
            property="reason"
            items={vm.exemptionReasonOptions}
            allowEmpty={vm.isCancelation}
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col}>
          {vm.item.excelFile ? (
            <File file={vm.item.excelFile} onRemoveClick={vm.onRemoveFileClick} error={vm.fileError} />
          ) : (
            <Uploader
              onDrop={vm.onDrop}
              localization={localizationProvider.uploaderLocalization}
              label=""
              accept=".xlsx"
              error={vm.fileError}
            />
          )}
        </Form.Group>
      </Form.Row>
    </>
  );
});

export default BulkExemptionsFormView;
